import { type MemberOnboardingProviderInNetworkMap } from 'utils/web_api.schemas'

import { ProvidersSummary } from './ProvidersSummary'

interface ProviderInNetworkMapProps {
  align?: 'start' | 'end';
  providerInNetworkMap: MemberOnboardingProviderInNetworkMap[];
  inNetworkProvidersCount: number;
  providerSupportLink?: string;
}

export const ProviderInNetworkMap = ({
  align,
  providerInNetworkMap,
  inNetworkProvidersCount,
  providerSupportLink,
}: ProviderInNetworkMapProps) => {
  const totalProviders = providerInNetworkMap.length
  return (
    <ProvidersSummary
      align={align}
      label={`${inNetworkProvidersCount}/${totalProviders} providers`}
      coverageIsGood={inNetworkProvidersCount / totalProviders >= 0.75}
    >
      {providerInNetworkMap.map((entry) => {
        const { name, in_network: inNetwork } = entry
        if (!name || inNetwork === undefined) {
          return null
        }

        return (
          <ProvidersSummary.Provider
            inNetworkStatus={inNetwork}
            lookupUrl={providerSupportLink ?? '#'}
            key={name}
          >
            {name}
          </ProvidersSummary.Provider>
        )
      })}
    </ProvidersSummary>
  )
}
